<template>
    <div id="pageDashboard" >
        <v-container grid-list-xl fluid>
            บรรจุสินค้า
        </v-container>
    </div>
</template>

<script>
import {mapActions } from 'vuex'

export default {
    name: 'shipmentpack',
    metaInfo: {
        title: 'บรรจุสินค้า',
    },
    components: {
        // VWidget,
        // MiniStatistic,
        // VCircle,
        // ProfileCard,
        // CircleStatistic,
        // LinearStatistic,
        // BoxChart
    },
    data: () => ({
    }),
    computed : {
    },
    methods:{
        ...mapActions('app', ['setTitleText']),
    },
    mounted(){
    }
}
</script>
